








































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import InteractiveData from '@/components/question/interactive_data/InteractiveData.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import ResetExamEditor from '@/components/ResetExamEditor.vue';
import FileBoxesEditor from '@/components/FileBoxesEditor.vue';

export default Vue.extend({
  components: {
    Content,
    InteractiveData,
    pxCard,
    SquareEditOutlineIcon,
    ArrowRightIcon,
    Loading,
    ResetExamEditor,
    FileBoxesEditor,
  },

  data() {
    return {
      loaded: true,
    };
  },

  computed: {
    ...mapGetters({
      exam: 'currentExam',
      fileBoxes: 'fileBoxes',
    }),
  },

  async created() {
    let examId = parseInt(this.$route.params.examId);
    if (!examId) examId = 22; //TODO landing page
    this.loaded = false;
    this.$store.dispatch('PULL_EXAM', examId);
    this.loaded = true;
  },
});
